import React, {Component} from 'react';
import {connect} from 'react-redux';
import {PropTypes} from 'prop-types';
import CardWidget from "../card-widget/CardWidget";
import CardWidgetContent from "../card-widget/CardWidgetContent";
import CardWidgetErrorsContainer from "../card-widget/CardWidgetErrorsContainer";
import Api from "../../services/api/Api";
import {ApiPaths} from "../../services/api/ApiPaths";
import {RouteConstants} from "../route/services/RouteConstants";
import {PASSWORD_RESET_STATUS} from "../password-reset/PasswordResetStatus";
import {getLanguage, getSecurityQuestions, isEnglishActive} from "../../store/rootReducer";

import SecurityQuestionAnswer from "../registration/fields/SecurityQuestionAnswer";
import _find from "lodash/find";
import UrlParamsUtil from "../../services/util/UrlParamsUtil";


class PasswordResetAuthForm extends Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      errorMessage: null,
      passwordResetToken: null,
      securityQuestionId: null,
      securityQuestionHint: null,
      securityQuestionAnswer: null,
    };
  }

    getSecurityQuestion = () => {
      let userSecurityQuestionId = this.state.securityQuestionId;
      if(!userSecurityQuestionId){
          return;
      }

      let result = _find(this.props.securityQuestions, { 'id': userSecurityQuestionId});
      if(this.props.isEnglishActive){
        return result.en;
      }else{
        return result.fr;
      }
    };

  submitSecurity = () => {
    let request = {
      "passwordResetToken": this.state.passwordResetToken,
      "securityQuestionId": this.state.securityQuestionId,
      "securityQuestionAnswer": this.state.securityQuestionAnswer
    };
    Api.post(ApiPaths.PASSWORD_RESET_AUTH, request).then(
        (response) => {
          if (response.data.status === PASSWORD_RESET_STATUS.AUTH_SUCCESS) {
            this.props.onAuthSuccess(this.state.passwordResetToken);
          } else if (response.data.status === PASSWORD_RESET_STATUS.INVALID_TOKEN) {
            this.props.history.push(RouteConstants.PASSWORD_RESET_ERROR);
          } else if (response.data.status === PASSWORD_RESET_STATUS.AUTH_FAILED) {
              let securityQuestionHint  = response.data.securityQuestionHint;
              if(securityQuestionHint){
                this.setState({
                    errorMessage: "password_reset_auth.password_reset_auth_failed_with_hint",
                    securityQuestionHint : securityQuestionHint
                });
              }else{
                this.setState({
                    errorMessage: "password_reset_auth.password_reset_auth_failed"
                });
              }

          }else {
            this.setState({
              errorMessage: "common.general_processing_error"
            });
          }
        },
        (error) => {
          this.setState({
            errorMessage: "common.general_processing_error"
          });
        });
  };

  onSecurityQuestionAnswerChanged = (e, errorMessage) => {
      let securityQuestionAnswer = e.target.value;
      this.setState(
        {
          securityQuestionAnswer: securityQuestionAnswer
        }
      );
  };


  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.state.securityQuestionAnswer) {
      this.submitSecurity();
    }
  };

  getCardContent = () => {
    return (
        <form onSubmit={(e) => this.handleSubmit(e)}>
            <CardWidgetContent contentText="password_reset_auth.password_reset_auth_desc"/>
            <div className="hrb-card-widget-content-text">
                <span>{this.getSecurityQuestion()}</span>
            </div>
          <CardWidgetErrorsContainer errorMessage={this.state.errorMessage} errorMessageParams={{"securityQuestionHint": this.state.securityQuestionHint}}/>
          <SecurityQuestionAnswer
            onChange={this.onSecurityQuestionAnswerChanged}
          />
        </form>
    )
  };

    componentDidMount() {
        let parsedParams = UrlParamsUtil.getQueryParamsFromUrl(this.props);
        if (parsedParams.token) {
            this.setState({
                passwordResetToken: parsedParams.token
            })
        }

        if (parsedParams.qId) {
            this.setState({
                securityQuestionId: parseInt(parsedParams.qId, 10)
            })
        }
    }

  render() {
    return (
        <CardWidget getCardContent={this.getCardContent}
                    isSubmitDisabled={!this.state.securityQuestionId || !this.state.securityQuestionAnswer}
                    submitButtonAction={() => this.submitSecurity()}
                    submitButtonText="forgotpassword.next"/>
    )
  };
}

const mapStateToProps = (state) => {
  return {
      language: getLanguage(state),
      isEnglishActive: isEnglishActive(state),
      securityQuestions: getSecurityQuestions(state)
  };
};

PasswordResetAuthForm.propTypes = {
  onAuthSuccess: PropTypes.func,
  passwordResetToken: PropTypes.string,
  securityQuestionId: PropTypes.string
};

export default connect(mapStateToProps)(PasswordResetAuthForm);